import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-alert-top',
  templateUrl: './alert-top.component.html',
  styleUrls: ['./alert-top.component.css']
})
export class AlertTOPComponent implements OnInit {
  public messages = '';
  public modalId = 'alert-top-modal';

  constructor(private authService: AuthenticationService, private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.onSameUrlNavigation = 'reload';
  }

  loadJQueryScript(): void {
    const that = this;

    $(document).ready(function () {
      $('#alert-top-modal').on('hidden.bs.modal', function () {
        that.router.navigate(['/dashboard']);
      });
    });
  }

  ngOnInit() {
    this.loadJQueryScript();
  }

  public show(message): void {
    this.messages = message;
    $(`#${this.modalId}`).modal('show');
  }

  public hide(): void {
    $(`#${this.modalId}`).modal('hide');
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
      this.router.navigate(['/dashboard']);
    }
  }

  public toHome() {
    this.hide();
    this.router.navigate(['/dashboard']);
  }
}
